var jingdian = [
    // —————— 和平区 ——————
    [123.427988, 41.806308, '老北市景区'],
    [123.424536, 41.807734, '中共满洲省委旧址纪念馆'],
    [123.407563, 41.734881, '沈阳市宋雨桂艺术馆'],

    // —————— 沈河区 ——————
    [123.455677, 41.798387, '沈阳故宫博物院'],
    [123.457791, 41.794058, '张学良旧居陈列馆'],
    [123.436324, 41.761326, '沈阳科学宫'],
    [123.440343, 41.759301, '沈阳市城市规划展示馆'],
    [123.425703, 41.789950, '沈阳十一号院艺术区'],
    [123.442184, 41.804877, '沈阳劳动模范纪念馆'],
    [123.551065, 41.823376, '辽宁农业博物馆'],

    // —————— 铁西区 ——————
    [123.163297, 41.674972, '华晨宝马铁西工厂'],
    [123.354792, 41.823012, '沈阳工业博物馆'],
    [123.350507, 41.811247, '红梅文创园'],
    [123.331038, 41.793675, '铁西工人村生活馆'],
    [123.395071, 42.736522, '奉天记忆文化创意产业园'],
    [123.072894, 41.698704, '拾壹·烟花小镇'],

    // —————— 皇姑区 ——————
    [123.433597, 41.864310, '沈飞航空博览园'],
    [123.428469, 41.851637, '沈阳北陵公园（清昭陵）'],
    [123.452076, 41.855638, '沈阳抗美援朝烈士陵园'],
    [123.415306, 41.846763, '沈阳新乐遗址博物馆'],
    [123.389398, 41.816813, '皇姑屯事件博物馆'],

    // —————— 大东区 ——————
    [123.466403, 41.834070, '沈阳“九·一八”历史博物馆'],
    [123.479634, 41.806516, '沈阳老龙口酒博物馆'],
    [123.489173, 41.805053, '龙之梦休闲旅游中心'],
    [123.439075, 41.783948, '沈阳EX元宇宙未来城'],

    // —————— 浑南区 ——————
    [123.649192, 41.862330, '沈阳植物园（沈阳世博园）'],
    [123.684231, 41.931788, '沈阳棋盘山风景区'],
    [123.684080, 41.928501, '沈阳森林动物园'],
    [123.592764, 41.828946, '沈阳东陵公园（清福陵）'],
    [123.460419, 41.675567, '辽宁省科学技术馆'],
    [123.459291, 41.677792, '辽宁省博物馆'],
    [123.606705, 41.826236, '沈阳鸟岛'],
    [123.723820, 41.955897, '沈阳华夏饮食文化博物馆'],
    [123.464675, 41.677576, '沈阳朝阳山风景区'],
    [123.751878, 41.995035, '沈阳花果山神秘谷景区'],

    // —————— 于洪区 ——————
    [123.330932, 41.848672, '丁香湖公园'],

    // —————— 沈北新区 ——————
    [123.637250, 42.060438, '沈阳怪坡风景区'],
    [123.418956, 41.963758, '沈阳方特欢乐世界'],
    [123.301132, 42.077934, '稻梦空间'],
    [123.550955, 42.049206, '北汤温泉'],
    [123.427648, 41.910643, '海蓝星梦幻城'],
    [123.517889, 42.154988, '辽河七星湖景区'],

    // —————— 苏家屯区 ——————
    [123.361364, 41.682561, '沈阳铁路陈列馆'],
    [123.720571, 41.575620, '沈阳体育学院白清寨滑雪场'],
    [123.583142, 41.511459, '马耳山风景区'],
    [123.474807, 41.482297, '杨城寨生态旅游景区'],

    // —————— 辽中区 ——————
    [122.864852, 41.708005, '辽中蒲河湿地公园'],
    [122.890202, 41.751278, '沈阳珍珠湖景区'],
    [122.968710, 41.685796, '花溪地温泉热带植物园'],

    // —————— 新民市 ——————
    [122.886511, 41.779036, '沈阳仙子湖风景旅游度假区'],
    [123.464675, 41.677576, '沈阳三农博览园'],
    [123.018136, 41.818268, '欧亚菲温泉水世界'],
    [123.132427, 41.815742, '溪溪湖湿地公园'],

    // —————— 康平县 ——————
    [123.370721, 42.384521, '卧龙湖省级旅游度假区'],
    [122.737463, 41.521301, '大辽圣市商业街'],

    // —————— 法库县 ——————
    [123.308568, 42.335334, '沈阳爱新觉罗皇家博物院'],
    [123.370721, 42.384521, '财湖旅游度假区'],
    [123.333388, 42.338660, '五龙山旅游风景区'],
    [123.448092, 42.498875, '白鹤楼景区'],
    [123.217580, 42.513089, '巴尔虎山景区'],

    // —————— 亲子乐园 & 儿童友好型重点景区 ——————
    [123.418956, 41.963758, '沈阳方特欢乐世界'],
    [123.427648, 41.910643, '海蓝星梦幻城'],
    [123.301132, 42.077934, '稻梦空间'],
    [123.684080, 41.928501, '沈阳森林动物园'],
    [123.649192, 41.862330, '沈阳植物园（世博园）'],
    [123.550955, 42.049206, '北汤温泉（含儿童戏水区）'],
    [123.350507, 41.811247, '红梅文创园（儿童手工工坊）'],
    [123.489173, 41.805053, '龙之梦休闲旅游中心（室内儿童乐园）'],
    [123.439075, 41.783948, '沈阳EX元宇宙未来城（沉浸式科技体验）'],
    [123.018136, 41.818268, '欧亚菲温泉水世界（大型室内水乐园）'],
    [123.330932, 41.848672, '丁香湖公园（免费儿童游乐区）']
];

var shenyang = [
    {
        name: '景点',
        group: 'base',
        list: jingdian,
        show: true,
        color: 'red'
    }
]


export default shenyang